import { render, staticRenderFns } from "./block_setting.vue?vue&type=template&id=23465710&"
import script from "./block_setting.vue?vue&type=script&lang=js&"
export * from "./block_setting.vue?vue&type=script&lang=js&"
import style0 from "./block_setting.vue?vue&type=style&index=0&id=23465710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports